import { combineReducers } from "redux";

import GetHeadingReducer, { GetAllAccountsReducer, GetAllRecentlyAccReducer } from "./getheading";
import { GetAllBanksReducer, GetAllCashReducer } from "./getbanks";
import { GetAllProjectCatReducer } from "./getprojectcat";
import { GetAllCRMProject, GetAllProject, GetAllProjectSearch } from "./getprojects";
import {
  GetsectioncatReducer,
  GetsectionsubcatReducer,
  GetsectiontypeReducer,
} from "./getsectioncat";
import { GetAllSections, GetCrmProjects } from "./getsections";

import { GetAllGeneralRec } from "./getgeneralrec";
import { GetAllGeneralPay } from "./getgeneralpay";
import { GetAllPurchasePay } from "./getpurchasepay";
import { GetAllClientReceipt } from "./getclientreceipt";
import { GetAllJournalEntry } from "./getjournalentry";
import {
  GetAllMeasureUnit,
  GetAllDimensionUnit,
  GetAllUnits,
  GetAllUnitCategory,
  GetAllUnitTags,
  GetUnitDetailsRed,
  GetUnitCategoryPopulate,
} from "./getunit";
import {
  GetAllClientsReducer,
  GetClientsdataReducer,
  GetAllCustomersRed,
  GetCustomersdataReducer,
} from "./getclients";
import { GetAllCreditorReducer, GetCreditordataReducer } from "./getcreditors";
import { GetAllUnitReceiptRed, GetAllUnitReceiptTableRed } from "./voucherreciept/getunitreceipt";
import {
  GetRecoveryBookingRed,
  GetAllRecoveryBookingTableRed,
} from "./voucherreciept/getrecoverybooking";
import { GetallManagersReducer } from "./getmanager";
import { GetLendersdataReducer, GetAllLendersReducer } from "./getlenders";
import { GetAllAccReceivable } from "./chartofacc/accreceivablereducer";
import { GetAllAccReceivableAgingDetail } from "./chartofacc/accreceivableagingdetailreducer";
import { GetAllAccReceivableAgingSummary } from "./chartofacc/accreceivableagingsummaryreducer";
import { GetAllAccPayableAgingSummary } from "./chartofacc/accpayableagingsummaryreducer";
import { GetAllAccPayableAgingDetail } from "./chartofacc/accpayableagingdetailreducer";
import { GetAllAccPayableAgingDetailTransaction } from "./chartofacc/accpayableagingdetailtransactionreducer";
import { GetAllAccPayable } from "./chartofacc/accpayablereducer";
import {
  GetRecoveryReceiptRed,
  GetAllRecoveryReceiptTableRed,
} from "./voucherreciept/getrecoveryreciept";
import { GetAllLoanReceiptTableRed, GetLoanReceiptRed } from "./voucherreciept/getlaonreceipt";
import { GetAllLoanTableRed } from "./getloanreducer";
import { GetAllLoanPaymentTableRed, GetLoanPaymentRed } from "./voucherreciept/getloanpayment";
import {
  GetAllReceiptInstallTableRed,
  GetReceiptInstallRed,
} from "./voucherreciept/getreceiptinstallment";
import { GetAllPaymentInstallTableRed } from "./voucherreciept/getpaymentintall";
import { GetAllLandByIdReducer, GetAllLandReducer } from "./inventoryreducers/addlandreducer";
import { GetAllAddDeals } from "./inventoryreducers/getadddeal";
import { GetAllLandPaymentPopulateRed, GetAllLandTableRed } from "./voucherreciept/getlandpayment";
import { GetDeveloperPaymentPopulateRed } from "./voucherreciept/developerpayment";
import {
  GetAllEmployeesReducer,
  GetEmployeedataReducer,
  GetEmpDesignation,
} from "./HRreducers/getemployees";
import { GetProjectDataReducer, GetAssignedProjectsReducer } from "./projectselectionred";
import { GetChartOfAcc } from "./chartofacc/getchartofacc";
import { GetTrailBalance } from "./AccountReports/trailbalance";

import { GetAllAffiliatesRed, GetAffliateEidtReducer } from "./inventoryreducers/getaffiliates";
import { GetAllDealSoldRed } from "./inventoryreducers/dealsold";
import { GetAllSellerReducer, GetSellerdataReducer } from "./inventoryreducers/addseller";
import { GetAllDealBoughtRed } from "./inventoryreducers/dealbought";
import {
  GetAllContractPopulateRed,
  GetContractDetailsPopulate,
  GetNominee,
  GetContractTable,
  GetContractTablePopulate,
  GetContracts,
  GetUnitPopulateRed,
} from "./accountsreducers/addcontract";
import {
  GetCommissionPaymentRed,
  GetAllCommissionPaymentTableRed,
} from "./voucherreciept/getcompayment";
import { GetDealBoughtPayRed, GetAllDealBoughtPayTableRed } from "./voucherreciept/dealboughtpay";
import {
  GetDealSoldReceiptRed,
  GetAllDealSoldReceiptTableRed,
} from "./voucherreciept/dealsoldreceipt";
import {
  GetAccBalanceSummary,
  cashSummaryReducer,
  cashSummaryReducer2,
  taxSummaryReducer,
  taxSummaryReducer2,
  coaSummaryReducer,
  coaSummaryReducer2,
  landPaymentReducer,
} from "./accdashboard/balancesummary";
import {
  flowSummaryReducer,
  pdcRadarReducer,
  investmentLiabilitiesReducer,
  arApAgingSummaryReducer,
  draftVouchersReducer,
} from "./accNewDashboard/flowsummary";
import {
  cashFlowDailyPositionReducer,
  cashFlowAgingReducer,
} from "./accNewDashboard/cashFlowReducer";
import {
  projectCostBudgetVsActualReducer,
  projectCostGranularReducer,
  projectCostOverrunsReducer,
} from "./accNewDashboard/projectCostReducer";
import {
  salesBalanceSummaryReducer,
  ballotingReadinessReducer,
  installmentForecastReducer,
  contractStatusReducer,
  rescheduleRiskReducer,
} from "./salesNewDashboard/balancesummary";
import {
  bookingTrendsReducer,
  installmentReportsReducer,
  overdueInstallmentsReducer,
} from "./salesNewDashboard/salesRecoveryReducer";
import { profitabilityMarginsReducer } from "./salesNewDashboard/profitabilityReducer";
import { executiveSnapshotReducer } from "./salesNewDashboard/executiveSnapshotReducer";
import {
  employeeSummaryReducer,
  advanceLoanSummaryReducer,
  attendancePatternsReducer,
  topLeaveTakersReducer,
  designationSalaryBreakdownReducer,
  workforceMixReducer,
} from "./hrNewDashboard/employeesummary";
import {
  totalInventoryValueReducer,
  inventoryAlertsReducer,
  inventoryCompositionReducer,
  inventoryTopSectionsReducer,
  inventoryRePurchasesReducer,
  affiliateLeaderboardReducer,
  inventoryDealProgressReducer,
} from "./inventoryNewDashboard/inventoryDashboardAPIs";
import {
  propertyBalanceSummaryReducer,
  propertyRevenueByChargeHeadReducer,
  propertyTopDefaultersReducer,
  propertyVoidAnalysisReducer,
  propertyPartialPaymentsReducer,
  propertyInactiveChargesReducer,
  propertyActiveBatchesStatusReducer,
} from "./propertyNewDashboard/balancesummary";
import rescheduleUnitReducer, {
  GetAllInstallRescedulePopulateRed,
  GetresceduledataReducer,
} from "./accountsreducers/installmentsrescedule";
import { GetBalanceSheet } from "./AccountReports/balancesheet";
import { GetProfitLoss } from "./AccountReports/profitandloss";
import { GetComReceiptRed, GetAllComReceiptTableRed } from "./voucherreciept/getcomreceipt";
import { GetAllGeneralAdjTableRed } from "./voucherreciept/generaladjustment";
import { GetAllTaxReducer, GetTaxDataReducer } from "./accountsreducers/addtax";
import {
  GetAllTaxPayableReducer,
  GetAllTaxPayableVoucherReducer,
} from "./accountsreducers/taxpayable";
import {
  GetAllTaxReceivableReducer,
  GetAllTaxReceiveableVoucherReducer,
} from "./accountsreducers/taxreceivable";
import { GetRecoveryReport } from "./AccountReports/recoveryreport";
import { GetAllNewPurchase, GetAddfilePopulate } from "./inventoryreducers/newpurchase";
import {
  GetRePurchaseTable,
  GetAllRePurchasePopulateRed,
} from "./inventoryreducers/repurchaseunit";
import {
  GetAllPopulateLeadRed,
  GetAllTableLeadRed,
  GetAllLeadTaskPopulateRed,
  GetAllLeadMeetingPopulateRed,
  GetAllLeadCallPopulateRed,
  GetAllLeadTasktableRed,
  GetAllLeadMeetingTabelRed,
  GetAllLeadCallTableRed,
} from "./crmreducer/leadreducer";
import { GetAllCRMAvailabilityRed, GetAllLeadsRed } from "./crmreducer/availabilityreducer";
import {
  GetAllDesignationReducer,
  GetAllAllowancesReducer,
  GetAllDeductionReducer,
} from "./HRreducers/designationred";
import { GetAllSalariesTable, GetAllSalariesPopulate } from "./HRreducers/assignsalary";
import {
  GetAllLoanTable,
  GetAllLoanPopulate,
  GetAllAdvanceTable,
} from "./HRreducers/advanceloanred";
import { GetAllHierarchyRed } from "./crmreducer/hierarchyred";
import {
  GetAllTeamsTable,
  GetAllTeamsPopulate,
  GetAllMemberPopulate,
  GetAllMemberTable,
} from "./crmreducer/addteamsred";
import {
  GetAssetsCatReducer,
  GetdepricationMethodReducer,
  GetAssetsSubcatReducer,
  GetTableAssetsReducer,
} from "./assetsreducer/addassets";
import { GetAssetBuyerdataReducer, GetAllAssetBuyerReducer } from "./assetsreducer/assetbuyer";
import { GetAllPaySlipBatchReducer, GetAllPaySlipTable } from "./HRreducers/payslipred";
import { GetAssetsDepReducer } from "./assetsreducer/depriciation";
import {
  GetAllTransferContractPopulateRed,
  GetTransferContractTable,
} from "./accountsreducers/transfercontract";
import {
  GetAllSalaryTableRed,
  GetAllSalaryPaymentPopulateRed,
} from "./voucherreciept/salarypayment";
import { GetAssetsSellReducer } from "./assetsreducer/assetssell";
import { GetAssetsMaintenenceReducer } from "./assetsreducer/maintenence";
import { GetAllRole, GetAllRoleTable } from "./getrole";
import {
  GetInstallmentReceiptRed,
  GetInstallmentPaymentRed,
} from "./AccountReports/installmentsreport";
import {
  GetComPaymentReportRed,
  commissionPaymentsReducer,
} from "./AccountReports/comissionpayment";
import { GetComReceiptReportRed } from "./AccountReports/comissionreceipt";
import { GetComPaymentSoldReportRed } from "./AccountReports/dealsoldcompay";
import { GetProjectsReportRed } from "./AccountReports/projectsreport";
import {
  GetAllUnSubmittedVouchers,
  unsubmittedVoucherReducer,
} from "./GetUnSubmittedVoucherReducer";
import { GetAllRevertBackVouchers } from "./GetRevertBackVoucherReducer";
import { GetAllRevertBackUserVouchers } from "./GetRevertBackUserVouchersReducer";
import { GetAllSubmittedVouchers } from "./GetSubmittedVoucherReducer";
import { GetExternalCommissionRed } from "./voucherreciept/getexternalcommission";
import {
  GetAllNotification,
  GetAllNotificationNew,
  GetPendingNotification,
} from "./GetAllNotificationReducer";
import { GetCompany } from "./GetCompanyInfoReducer";
import { GetBookedUnits } from "./BookedUnits/BookedUnits";
import { GetAllRoles, GetAllRolesCRM } from "./populateRoles";
import { GetFetchUserData } from "./Users/getUser";
import { GetAllRefund } from "./getrefundvouch";
import { GetAllRefundPopulate } from "./getrefundpopulate";
import { GetLandPendingAmountRed } from "./AccountReports/landinstalltracker";
import { GetCancelPlotPaymentRed } from "./AccountReports/cancelplotpayment";
import {
  GetAllTransferUnitPopulateRed,
  GetTransferUnitTable,
} from "./accountsreducers/transferunit";
import { GetRepurchasedUnitsSummaryreport } from "./AccountReports/RepurchasedUnitsSummary";
import {
  inventoryPieChartRed,
  invSectionUnitRed,
  invSectionWiseUnitRed,
  invAllProjectsRed,
} from "./inventoryreducers/dashboard";
import {
  customerLedgerReducer,
  generalLedgerReducer,
  generalLedgerDataReducer,
  installmentRecoveryReducer,
  reserveCommissionPayableReducer,
  trialBalanceReducer,
  waHistoryReducer,
  GetCustomerReportRed,
  cashBookReducer,
  bankBalanceReducer,
  generalJournalReducer,
  commissionReceiptsReducer,
} from "./AccountReports/reports";
import { dashboardReducer, dashboardDesReducer } from "./HRreducers/dashbaord";

import dealPaymentReducer, {
  pdcPayableReducer,
  pdcReceiptReducer,
  generalReceiptReducer,
  unitReceiptPrintReducer,
} from "./accountsreducers/vouchers";

import { GetAllAccReceivableAgingDetailTransaction } from "./chartofacc/accreceivableagingdetailtransactionreducer";
import { GetAllTermsAndConditionsRed } from "./inventoryreducers/termsandcondition";
import { GetAllScreens } from "./populateScreens";
import { GetWAInstance } from "./populateWAInstance";
import { GetAllDeletionAuditLogsReducer } from "./getdeletionauditlogs";
import { GetProjectsCOAMaxLevelReducer } from "./GetProjectsCOAMaxLevelReducer";
// import {
//   GetAllExpenseVoucherRed,
//   GetExpenseTagsRed,
//   GetExpTagsRed,
// } from "./getexpensevouch";
// import { GetCostCenterDetailsRed, GetCostCenterSummaryRed } from "./getcostcenter";
// import {
//   GetAllChargeHeadRed,
//   GetAddChargeHeadPopulateRed,
// } from "./propertyreducers/chargehead";
import { GetAllExpenseVoucherRed, GetExpenseTagsRed, GetExpTagsRed } from "./getexpensevouch";
import { GetCostCenterDetailsRed, GetCostCenterSummaryRed } from "./getcostcenter";
import { GetAllChargeHeadRed, GetAddChargeHeadPopulateRed } from "./propertyreducers/chargehead";
import {
  GetAddInvoicePopulateRed,
  GetAddUnitInvoicePopulateRed,
  GetAllInvoiceRed,
  GetAllVoidInvoiceRed,
} from "./propertyreducers/invoice";
import { GetAllInvoiceRec, GetAllInvoiceRecPopulate } from "./propertyreducers/invoiceReceipt";
import {
  GetAllBalanceSummary,
  GetAllChargeHeadInvoices,
  GetAllChargeHeadSummary,
} from "./propertyreducers/propertyDashboard";
import { GetAllPopulateUsers, GetContractComments } from "./accountsreducers/contractComments";
import {
  GetUserContractsData,
  GetUserDashboardData,
  GetUserInstallmentsReport,
  GetUserPaymentsReport,
} from "./Users/getUserDashboard";
import { GetUserProfile } from "./Users/getUserProfile";
import { GetBusinessProfile, GetPersonalProfile } from "./Business/getBusinessProfile";
import { GetBallot, GetBallotData } from "./accountsreducers/ballot";
import ChatWidgetReducer from "./ChatWidget/ChatWidgetSlice";
import { GetMessageAutomationData } from "./MessageAutomation/getMessageAutomation";
import { GetAllApprovalsRed } from "./getapprovals";
import { GetAllContractorsReducer } from "./Operationsreducers/getcontractors";
import { GetAllVendorsReducer } from "./Operationsreducers/getvendors";
import { GetAllWorkOrdersReducer } from "./Operationsreducers/getworkorders";
import { GetAllPurchaseOrdersReducer } from "./Operationsreducers/getpurchaseorders";
import { GetPurchaseOrderByIdReducer } from "./Operationsreducers/getpurchaseorderbyid";
import { GetWorkOrderByIdReducer } from "./Operationsreducers/getworkorderbyid";
import { GetAllUOMReducer } from "./Operationsreducers/getuom";
import { GetAllCategoryReducer } from "./Operationsreducers/getcategory";
import { GetAllMaterialReducer } from "./Operationsreducers/getmaterial";
import { GetAllGatepassReducer } from "./Operationsreducers/getgatepass";
import { GetAllStockReducer } from "./Operationsreducers/getstock";
import {
  GetRegistryProjectRed,
  GetRegistrySummaryRed,
  GetRegistryVendorsRed,
  GetRegistryVendorTypesRed,
  GetRegistryChargeHeadsRed,
  GetRegistryChargeHeadTypesRed,
  GetRegistryStagesRed,
  GetRegistryCasesRed,
  GetRegistryEligibleSalesRed,
  GetRegistryReceiptsRed,
  GetRegistryReceiptPopulateRed,
  GetRegistryCaseChargeSummaryRed,
  GetRegistryPaymentsRed,
  GetRegistryPaymentPopulateRed,
  GetRegistryCaseChargeSpentRed,
} from "./registryreducers/registry";

const MainReducer = combineReducers({
  getHeadingReducer: GetHeadingReducer,
  getAllAccountsReducer: GetAllAccountsReducer,
  getRecentlyAccRed: GetAllRecentlyAccReducer,
  getAllBanksReducer: GetAllBanksReducer,
  getProjectCat: GetAllProjectCatReducer,
  getProject: GetAllProject,
  getCRMProject: GetAllCRMProject,
  getProjectSearch: GetAllProjectSearch,
  getsectionsubcat: GetsectionsubcatReducer,
  getsectiontype: GetsectiontypeReducer,
  getsectioncat: GetsectioncatReducer,
  getAllSections: GetAllSections,
  getCrmProjects: GetCrmProjects,
  getAllGeneralRec: GetAllGeneralRec,
  getAllGeneralPay: GetAllGeneralPay,
  getAllPurchasePay: GetAllPurchasePay,
  getAllClientReceipt: GetAllClientReceipt,
  getAllJournalEntry: GetAllJournalEntry,
  getAllDimensionUnit: GetAllDimensionUnit,
  getAllMeasureUnit: GetAllMeasureUnit,
  getAllUnits: GetAllUnits,
  getAllUnitCategory: GetAllUnitCategory,
  getUnitCategoryPopulate: GetUnitCategoryPopulate,
  getAllUnitTags: GetAllUnitTags,
  getAllClients: GetAllClientsReducer,
  getAllCreditors: GetAllCreditorReducer,
  getClientsdatastate: GetClientsdataReducer,
  getCreditordatastate: GetCreditordataReducer,
  getSellerdatastate: GetSellerdataReducer,
  getAllSellers: GetAllSellerReducer,
  getAllUnitPopulate: GetAllUnitReceiptRed,
  getUnitReceiptTable: GetAllUnitReceiptTableRed,
  getAllManagers: GetallManagersReducer,
  getRecoveryBookingPopulate: GetRecoveryBookingRed,
  getRecoveryBookingTable: GetAllRecoveryBookingTableRed,
  getAllLenders: GetAllLendersReducer,
  getLendersdatastate: GetLendersdataReducer,
  getAccReceivable: GetAllAccReceivable,
  getAccReceivableagingdetail: GetAllAccReceivableAgingDetail,
  getAccReceivableagingdetailtransaction: GetAllAccReceivableAgingDetailTransaction,
  getAccPayableagingdetail: GetAllAccPayableAgingDetail,
  getAccPayableagingdetailtransaction: GetAllAccPayableAgingDetailTransaction,
  getAccReceivableagingsummary: GetAllAccReceivableAgingSummary,
  getAccPayableagingsummary: GetAllAccPayableAgingSummary,
  getAccPayable: GetAllAccPayable,
  getRecoveryReceipt: GetRecoveryReceiptRed,
  getAllRReceiptTable: GetAllRecoveryReceiptTableRed,
  getAllLoanReceiptTable: GetAllLoanReceiptTableRed,
  getLoanReceiptPopulate: GetLoanReceiptRed,
  getLoanTable: GetAllLoanTableRed,
  getLoanPaymentPopulate: GetLoanPaymentRed,
  getLoanPaymentTable: GetAllLoanPaymentTableRed,
  getReceiptInstallTable: GetAllReceiptInstallTableRed,
  getReceiptInstallPopulate: GetReceiptInstallRed,
  getPaymentInstallTable: GetAllPaymentInstallTableRed,
  getAllLand: GetAllLandReducer,
  getAddDeals: GetAllAddDeals,
  getLandTable: GetAllLandTableRed,
  getLandPaymentPopulate: GetAllLandPaymentPopulateRed,
  getDeveloperPaymentPopulate: GetDeveloperPaymentPopulateRed,
  getEmployeedatastate: GetEmployeedataReducer,
  getAllEmployees: GetAllEmployeesReducer,
  getProjectDataRed: GetProjectDataReducer,
  getChartOfAcc: GetChartOfAcc,
  getTrailBalance: GetTrailBalance,
  GetRepurchasedUnitsSummaryreport,
  getAllCustomersRed: GetAllCustomersRed,
  getCustomerReport: GetCustomerReportRed,
  getCustomersdata: GetCustomersdataReducer,
  getAffliateEdit: GetAffliateEidtReducer,
  getAffiliatesRed: GetAllAffiliatesRed,
  getAllDealSoldRed: GetAllDealSoldRed,
  getDealBoughtRed: GetAllDealBoughtRed,
  getContractPopulate: GetAllContractPopulateRed,
  getContractTable: GetContractTable,
  getContracts: GetContracts,
  getUnitPopulate: GetUnitPopulateRed,
  getCommissionPayment: GetCommissionPaymentRed,
  getAllCommissionPaymentTable: GetAllCommissionPaymentTableRed,
  getDealBoughtPayTable: GetAllDealBoughtPayTableRed,
  getDealBoughtPay: GetDealBoughtPayRed,
  getDealSoldReceipt: GetDealSoldReceiptRed,
  getAllDealSoldReceiptTable: GetAllDealSoldReceiptTableRed,
  getAccBalanceSummary: GetAccBalanceSummary,
  flowSummary: flowSummaryReducer,
  pdcRadar: pdcRadarReducer,
  investmentLiabilities: investmentLiabilitiesReducer,
  arApAgingSummary: arApAgingSummaryReducer,
  draftVouchers: draftVouchersReducer,
  cashFlowDailyPosition: cashFlowDailyPositionReducer,
  cashFlowAging: cashFlowAgingReducer,
  projectCostBudgetVsActual: projectCostBudgetVsActualReducer,
  projectCostGranular: projectCostGranularReducer,
  projectCostOverruns: projectCostOverrunsReducer,
  salesBalanceSummary: salesBalanceSummaryReducer,
  ballotingReadiness: ballotingReadinessReducer,
  installmentForecast: installmentForecastReducer,
  contractStatus: contractStatusReducer,
  rescheduleRisk: rescheduleRiskReducer,
  bookingTrends: bookingTrendsReducer,
  installmentRecovery: installmentRecoveryReducer,
  profitabilityMargins: profitabilityMarginsReducer,
  executiveSnapshot: executiveSnapshotReducer,
  employeeSummary: employeeSummaryReducer,
  advanceLoanSummary: advanceLoanSummaryReducer,
  attendancePatterns: attendancePatternsReducer,
  topLeaveTakers: topLeaveTakersReducer,
  designationSalaryBreakdown: designationSalaryBreakdownReducer,
  workforceMix: workforceMixReducer,
  getAllInstallRescedulePopulate: GetAllInstallRescedulePopulateRed,
  getresceduledata: GetresceduledataReducer,
  getBalanceSheet: GetBalanceSheet,
  getProfitLoss: GetProfitLoss,
  getAllComReceiptTable: GetAllComReceiptTableRed,
  getComReceipt: GetComReceiptRed,
  getGeneralAdjTable: GetAllGeneralAdjTableRed,
  getTaxData: GetTaxDataReducer,
  getAllTaxTable: GetAllTaxReducer,
  getAllCash: GetAllCashReducer,
  getAllTaxPayable: GetAllTaxPayableReducer,
  getAllTaxPayableVoucher: GetAllTaxPayableVoucherReducer,
  GetAllTaxReceiveableVoucher: GetAllTaxReceiveableVoucherReducer,
  GetAllTaxReceivable: GetAllTaxReceivableReducer,
  getRecoveryReport: GetRecoveryReport,
  getAllNewPurchase: GetAllNewPurchase,
  getAddfilePopulate: GetAddfilePopulate,
  getRePurchaseTable: GetRePurchaseTable,
  getRePurchasePopulate: GetAllRePurchasePopulateRed,
  getEmpDesignation: GetEmpDesignation,
  getTableLeads: GetAllTableLeadRed,
  getPopulateLeads: GetAllPopulateLeadRed,
  getLeadTaskPopulate: GetAllLeadTaskPopulateRed,
  getLeadMeetingPopulate: GetAllLeadMeetingPopulateRed,
  getLeadCallPopulate: GetAllLeadCallPopulateRed,
  getLeadTasktable: GetAllLeadTasktableRed,
  getLeadMeetingTabe: GetAllLeadMeetingTabelRed,
  getLeadCallTable: GetAllLeadCallTableRed,
  getCRMAvailability: GetAllCRMAvailabilityRed,
  getallLeadsred: GetAllLeadsRed,
  getallAllowances: GetAllAllowancesReducer,
  getAllDesignation: GetAllDesignationReducer,
  getAllSalariesPopulate: GetAllSalariesPopulate,
  getAllSalariesTable: GetAllSalariesTable,
  GetAllLoanPopulate,
  GetAllLoanTable,
  GetAllAdvanceTable,
  GetAllHierarchy: GetAllHierarchyRed,
  GetAllTeamsPopulate,
  GetAllTeamsTable,
  GetAllMemberPopulate,
  GetAllMemberTable,
  GetAssetsSubcat: GetAssetsSubcatReducer,
  GetAssetsCat: GetAssetsCatReducer,
  GetdepricationMethod: GetdepricationMethodReducer,
  GetAllAssetBuyerReducer,
  GetAssetBuyerdataReducer,
  GetTableAssetsReducer,
  GetAllPaySlipTable,
  getAllPaySlipBatch: GetAllPaySlipBatchReducer,
  GetAllDeductionReducer,
  GetAssetsDepReducer,
  GetTransferContractTable,
  GetTransferUnitTable,
  getAllExpenseVoucherRed: GetAllExpenseVoucherRed,
  getExpTagsRed: GetExpTagsRed,
  getExpenseTagsRed: GetExpenseTagsRed,
  GetTransferContractPopulate: GetAllTransferContractPopulateRed,
  GetTransferUnitPopulate: GetAllTransferUnitPopulateRed,
  GetAllSalaryPaymentPopulate: GetAllSalaryPaymentPopulateRed,
  GetAllSalaryTable: GetAllSalaryTableRed,
  GetAssetsMaintenence: GetAssetsMaintenenceReducer,
  GetAssetsSell: GetAssetsSellReducer,
  GetAllRole,
  GetAllRoleTable,
  GetInstallmentPayment: GetInstallmentPaymentRed,
  GetInstallmentReceipt: GetInstallmentReceiptRed,
  GetComPaymentReport: GetComPaymentReportRed,
  GetComReceiptReport: GetComReceiptReportRed,
  GetComPaymentSoldReport: GetComPaymentSoldReportRed,
  GetProjectsReportRed,
  getAllUnSubmittedVouchers: GetAllUnSubmittedVouchers,
  getAllRevertBackVouchers: GetAllRevertBackVouchers,
  getAllRevertBackUserVouchers: GetAllRevertBackUserVouchers,
  getAllSubmittedVouchers: GetAllSubmittedVouchers,
  getallsNotification: GetAllNotification,
  getPendingNotification: GetPendingNotification,
  getnotificationsNew: GetAllNotificationNew,
  getContractTablePopulate: GetContractTablePopulate,

  getContractDetails: GetContractDetailsPopulate,
  getExternalCommission: GetExternalCommissionRed,
  getCompany: GetCompany,
  getBookedUnits: GetBookedUnits,
  getRoles: GetAllRoles,
  getRolesCRM: GetAllRolesCRM,
  getWhatsAppInstance: GetWAInstance,
  getScreens: GetAllScreens,
  getFetchUserData: GetFetchUserData,
  getAllRefund: GetAllRefund,
  getAllRefundPopulate: GetAllRefundPopulate,
  getAllLandById: GetAllLandByIdReducer,
  GetLandPendingAmount: GetLandPendingAmountRed,
  GetCancelPlotPayment: GetCancelPlotPaymentRed,
  inventoryPieChart: inventoryPieChartRed,
  inventorySectionUnit: invSectionUnitRed,
  invSectionWiseUnit: invSectionWiseUnitRed,
  invAllProjects: invAllProjectsRed,
  assignedProjects: GetAssignedProjectsReducer,
  GetNominee,
  cashSummary: cashSummaryReducer,
  cashSummary2: cashSummaryReducer2,
  taxSummary: taxSummaryReducer,
  taxSummary2: taxSummaryReducer2,
  coaSummary: coaSummaryReducer,
  coaSummary2: coaSummaryReducer2,
  landPayment: landPaymentReducer,
  customerLedger: customerLedgerReducer,
  generalLedger: generalLedgerReducer,
  generalLedgerData: generalLedgerDataReducer,
  installmentReportsRecovery: installmentReportsReducer,
  overdueInstallments: overdueInstallmentsReducer,
  whatsappHistory: waHistoryReducer,
  reserveCommissionPayable: reserveCommissionPayableReducer,
  trialBalance: trialBalanceReducer,
  cashBook: cashBookReducer,
  bankBalance: bankBalanceReducer,
  unsubmittedVoucher: unsubmittedVoucherReducer,
  dashboardData: dashboardReducer,
  dashboardDes: dashboardDesReducer,
  rescheduleUnit: rescheduleUnitReducer,
  dealPayment: dealPaymentReducer,
  generalReceipt: generalReceiptReducer,
  unitReceiptPrint: unitReceiptPrintReducer,
  pdcPayable: pdcPayableReducer,
  pdcReceipt: pdcReceiptReducer,
  commissionPayment: commissionPaymentsReducer,
  generalJournal: generalJournalReducer,
  commissionReceipt: commissionReceiptsReducer,
  getAllTermsAndConditions: GetAllTermsAndConditionsRed,
  getUnitDetails: GetUnitDetailsRed,
  getCostCenterSummary: GetCostCenterSummaryRed,
  getCostCenterDetails: GetCostCenterDetailsRed,
  getRegistryProjectRed: GetRegistryProjectRed,
  getRegistrySummaryRed: GetRegistrySummaryRed,
  getRegistryVendorsRed: GetRegistryVendorsRed,
  getRegistryVendorTypesRed: GetRegistryVendorTypesRed,
  getRegistryChargeHeadsRed: GetRegistryChargeHeadsRed,
  getRegistryChargeHeadTypesRed: GetRegistryChargeHeadTypesRed,
  getRegistryStagesRed: GetRegistryStagesRed,
  getRegistryCasesRed: GetRegistryCasesRed,
  getRegistryEligibleSalesRed: GetRegistryEligibleSalesRed,
  getRegistryReceiptsRed: GetRegistryReceiptsRed,
  getRegistryReceiptPopulateRed: GetRegistryReceiptPopulateRed,
  getRegistryCaseChargeSummaryRed: GetRegistryCaseChargeSummaryRed,
  getRegistryPaymentsRed: GetRegistryPaymentsRed,
  getRegistryPaymentPopulateRed: GetRegistryPaymentPopulateRed,
  getRegistryCaseChargeSpentRed: GetRegistryCaseChargeSpentRed,
  getChargeHeadRed: GetAllChargeHeadRed,
  getAddChargeHeadPopulateRed: GetAddChargeHeadPopulateRed,
  getInvoiceRed: GetAllInvoiceRed,
  getVoidInvoiceRed: GetAllVoidInvoiceRed,
  getAddInvoicePopulateRed: GetAddInvoicePopulateRed,
  getAddUnitInvoicePopulateRed: GetAddUnitInvoicePopulateRed,
  getAllInvoiceRec: GetAllInvoiceRec,
  getAddInvoiceRecPopulateRed: GetAllInvoiceRecPopulate,
  getAllBalanceSummary: GetAllBalanceSummary,
  propertyBalanceSummary: propertyBalanceSummaryReducer,
  propertyRevenueByChargeHead: propertyRevenueByChargeHeadReducer,
  propertyTopDefaulters: propertyTopDefaultersReducer,
  propertyVoidAnalysis: propertyVoidAnalysisReducer,
  propertyPartialPayments: propertyPartialPaymentsReducer,
  propertyInactiveCharges: propertyInactiveChargesReducer,
  propertyActiveBatchesStatus: propertyActiveBatchesStatusReducer,
  getAllChargeHeadInvoices: GetAllChargeHeadInvoices,
  getAllChargeHeadSummary: GetAllChargeHeadSummary,
  getAllContractComments: GetContractComments,
  getAllPopulateUsers: GetAllPopulateUsers,
  getUserDashboardData: GetUserDashboardData,
  getUserContractsData: GetUserContractsData,
  getUserInstallmentsReport: GetUserInstallmentsReport,
  getUserPaymentsReport: GetUserPaymentsReport,
  getUserProfile: GetUserProfile,
  getBusinessProfile: GetBusinessProfile,
  getPersonalProfile: GetPersonalProfile,
  getAllBallot: GetBallot,
  getAllBallotData: GetBallotData,
  ChatWidget: ChatWidgetReducer,
  totalInventoryValue: totalInventoryValueReducer,
  inventoryAlerts: inventoryAlertsReducer,
  inventoryComposition: inventoryCompositionReducer,
  inventoryTopSections: inventoryTopSectionsReducer,
  inventoryRePurchases: inventoryRePurchasesReducer,
  affiliateLeaderboard: affiliateLeaderboardReducer,
  inventoryDealProgress: inventoryDealProgressReducer,
  getMessageAutomationData: GetMessageAutomationData,
  getAllDeletionAuditLogs: GetAllDeletionAuditLogsReducer,
  getAllApprovals: GetAllApprovalsRed,
  getAllContractors: GetAllContractorsReducer,
  getAllVendors: GetAllVendorsReducer,
  getAllWorkOrders: GetAllWorkOrdersReducer,
  getAllPurchaseOrders: GetAllPurchaseOrdersReducer,
  getPurchaseOrderDetails: GetPurchaseOrderByIdReducer,
  getWorkOrderDetails: GetWorkOrderByIdReducer,
  getAllUOM: GetAllUOMReducer,
  getAllCategory: GetAllCategoryReducer,
  getAllMaterial: GetAllMaterialReducer,
  getAllGatepass: GetAllGatepassReducer,
  getAllStock: GetAllStockReducer,
  getProjectsCOAMaxLevel: GetProjectsCOAMaxLevelReducer,
});
const AllReducers = (state, action) => {
  if (action.type === "CLEAR_REDUX") {
    state = undefined;
  }
  return MainReducer(state, action);
};
export default AllReducers;
